<div class="standard-slider-container">
    <div class="standard-slider">
        <form>
            <label [for]="id">{{ label }}</label>

            @if (!hideInputField) {
                <div class="input-group mb-3">
                    <div class="input-group-prepend">
                        @if (unit) {
                            <span class="input-group-text standard-slider-input" id="add-on-text">{{ unit }}</span>
                        }
                    </div>
                    <input
                        type="number"
                        [disabled]="disabled"
                        class="form-control standard-slider-input"
                        [(ngModel)]="data"
                        (input)="onChange()"
                        (change)="onChange()"
                        (blur)="onTouchedFn()"
                        [id]="id"
                        [name]="id"
                        aria-describedby="add-on-text"
                    />
                </div>
            }

            <div class="d-flex flex-row justify-content-between fs-6 pt-1">
                <div id="min" class="fw-medium me-2 min-container-padding">{{ minValue }}</div>

                <div class="position-relative flex-grow-1">
                    <output #bubble id="bubble"></output>

                    <input
                        id="slider"
                        type="range"
                        [min]="minValue"
                        [max]="maxValue"
                        [step]="step"
                        class="form-range"
                        [ngModelOptions]="{ standalone: true }"
                        [disabled]="disabled"
                        [(ngModel)]="data"
                        (input)="onChange()"
                        (change)="onChange()"
                        (blur)="onTouchedFn()"
                        [ngbTooltip]="tooltipText"
                        placement="bottom"
                    />
                </div>

                <div id="max" class="fw-medium ms-2 max-container-padding">{{ maxValue }}</div>
            </div>
        </form>
    </div>
    <div>
        @if (hint?.length) {
            <small class="form-text text-muted d-block mt-1"><i class="far fa-hand-point-right"></i>{{ hint }}</small>
        }
    </div>
</div>
